import { styled } from "@mui/material/styles";
import { Button, Card, Grid } from "@mui/material";
import { useColors } from "../../Context/ColorsContext"
import { MediaQuerys } from "../../styles/GlobalStyle";

const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;

export const DownloadButton = styled(Button)(() => {
    const { colors } = useColors();
    return {
        height: '100%',
        width: '100%',
        padding: "0 20px",
        backgroundColor: colors.buttonActionColor,
        color: colors.white,
        "&:hover": {
            backgroundColor: colors.buttonActionColor,
            opacity: 0.9,
            color: colors.white
        }
    }
})

export const ContainerButtonCreate = styled('div')(() => ({
	width: 170,
	height: 40,
	[desktop]: {
		width: "120px",
		height: "30px",
		"& button": {
			padding: "14px 12px",
			fontSize: "0.55rem",
		},
	},
	[tablet]: {
		width: "110px",
		height: 20,
		"& button": {
			fontSize: "7px",
		},
	},
}))

export const Content = styled(Card)(() => ({
  padding: 20,
	marginTop: '8px',
}));

export const Label = styled('label')(({nextline, istitle}) => {
	const { colors } = useColors();
	return {
		fontWeight:'bold',
		paddingRight:'5px',
		display: nextline ? 'block' : 'inherit',
		color: istitle ? colors.blue : colors.blackFont,
		paddingLeft: istitle ? 10 : 0,
		textTransform: istitle ? 'uppercase' : 'none',
		[desktop]: {
			fontSize: '0.85rem'
		},
	}
})

export const ContainerTitle = styled('div')(({ marginLeft }) => {
    return {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        marginLeft: marginLeft ? marginLeft : null,
    }
})

export const ContainerPageTitle = styled('div')(() => {
	return {
		display: 'flex',
		flexDirection: 'row',
		gap: '1rem'
	}
});

export const GridContainer = styled(Grid)(({ theme }) => {
	return {
		height: 'auto',
    [theme.breakpoints.down('md')]: {
      overflowY: 'auto',
    }
	}
});

export const GridMap = styled(Grid)(({ theme }) => {
	return {
		overflowY: 'auto',
    '@media (max-height: 480px)': {
      height: 'calc(100vh - 170px)',
    },
    '@media (min-height: 481px)': {
      height: 'calc(100vh - 170px)',
    },
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      marginBottom: '2rem',
		  overflowY: 'hidden',
    }
	}
});